import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeTrackerMeal } from '../helpers/normalizers';
import { TrackerMealProps } from '../types';

const TrackerMealContainer: React.FC<TrackerMealProps> = (props) => {
  const normalizedProps = normalizeTrackerMeal(props);
  sessionStorage.setItem('tracker_depth', '1');

  return <TrackerAddEditMeal key={normalizedProps.mealData.id} {...normalizedProps} />;
};

export default withLoading(TrackerMealContainer, UniversalPlaceholder);
